module.exports = __webpack_public_path__ + "img/quill-redo-hover.02225695.svg";